export const defaultImageQuality = 45;
export const maxImageQuality = 100;
